var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEngineering(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0992 27.668H46.5885V33.1581L42.1392 33.7142C41.7119 35.8106 40.886 37.7627 39.7442 39.4877L42.4994 43.03L38.6172 46.9122L35.0748 44.157C33.3501 45.2988 31.3979 46.1249 29.3014 46.552L28.7454 51.0013H23.2553L22.6991 46.552C20.6028 46.1247 18.6508 45.2988 16.9257 44.157L13.3834 46.9122L9.50122 43.03L12.2564 39.4877C11.1146 37.7629 10.2886 35.8108 9.86138 33.7142L5.41211 33.1581V27.668H16.9013C16.6391 28.5368 16.4981 29.4585 16.4981 30.4131C16.4981 35.6575 20.756 39.9154 26.0004 39.9154C31.2448 39.9154 35.5027 35.6575 35.5027 30.4131C35.5026 29.4585 35.3615 28.5367 35.0992 27.668Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0984 27.668C35.3607 28.5368 35.5016 29.4585 35.5016 30.4131C35.5016 35.6575 31.2437 39.9154 25.9994 39.9154C20.755 39.9154 16.4971 35.6575 16.4971 30.4131C16.4971 29.4586 16.638 28.5368 16.9003 27.668H35.0984Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6665 19.334H4.3331L2.6665 27.6674H49.3331L47.6665 19.334Z",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1 27.668H51",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 7.6667V1H21V7.6667",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0003 3.29883C38.5704 5.24997 44.411 11.5279 45.7232 19.3343H6.27734C7.58958 11.5279 13.4301 5.24997 21.0003 3.29883",
    stroke: "#EB2019",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEngineering);
export default __webpack_public_path__ + "static/media/icon-engineering.4e975772cda27c1383c297a21bad3e2f.svg";
export { ForwardRef as ReactComponent };